<script>
import { platformMeta } from '@modules/crm/constants/Transcript'

// Badge da origem da reunião, exibido ao lado do título no modal de detalhe.
export default {
  name: 'TranscriptPlatformBadge',
  props: {
    platform: { type: String, default: '' },
  },
  computed: {
    platformLabel() {
      return platformMeta(this.platform).label
    },
    hasPlatform() {
      return Boolean(this.platformLabel)
    },
  },
}
</script>

<template>
  <BaseStatus
    v-if="hasPlatform"
    soft
    preserveCase
    color="primary"
    :content="platformLabel"
  />
</template>
